import React, { useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-[#8B4513]/20 last:border-0" data-id="element-153">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between py-4 text-left group focus:outline-none" aria-expanded={isOpen} data-id="element-154">
        <span className="font-serif font-bold text-lg text-[#2D241E] group-hover:text-[#7C2D2D] transition-colors pr-4" data-id="element-155">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-[#8B4513] transition-transform duration-300 flex-shrink-0 ${isOpen ? 'transform rotate-180' : ''}`} data-id="element-156" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 mb-4' : 'max-h-0 opacity-0'}`} data-id="element-157">
        <p className="font-sans text-[#5D4037] leading-relaxed pr-8" data-id="element-158">
          {answer}
        </p>
      </div>
    </div>;
}
export function FAQSection() {
  const faqs = [{
    question: '¿Necesito tener cuenta en Mercado Pago?',
    answer: 'No. Mercado Pago es solo la pasarela de pagos segura que utilizamos. Podés pagar con cualquier tarjeta de crédito o débito sin necesidad de crearte una cuenta o iniciar sesión.'
  }, {
    question: '¿Cuándo recibo el material?',
    answer: 'Al instante. Apenas se acredita el pago (que suele ser inmediato con tarjeta), el sistema te envía automáticamente un email con los links de descarga de todos los PDFs y bonos.'
  }, {
    question: '¿Puedo pagar en cuotas?',
    answer: 'Sí, podés pagar con tarjeta de crédito en cuotas a través de Mercado Pago. Las opciones de financiación dependen de tu banco.'
  }, {
    question: '¿Sirve para cualquier provincia?',
    answer: 'Sí. Los contenidos están organizados por períodos históricos universales y procesos generales, por lo que son perfectamente adaptables a cualquier diseño curricular jurisdiccional de nivel secundario en Argentina y Latinoamérica.'
  }, {
    question: '¿Qué pasa si no me gusta?',
    answer: 'Tenés 7 días de garantía total. Si el material no cumple tus expectativas o sentís que no se adapta a tus clases, nos enviás un email y te reintegramos el 100% de tu dinero sin hacer preguntas.'
  }, {
    question: '¿Puedo imprimir los materiales?',
    answer: 'Sí, todos los PDFs están diseñados en alta calidad y optimizados para impresión en formato A4, tanto en color como en blanco y negro.'
  }, {
    question: '¿Es material actualizado?',
    answer: 'Sí. El contenido está pensado para el nivel secundario actual, con enfoques pedagógicos modernos, actividades dinámicas y recursos visuales que conectan con los estudiantes de hoy.'
  }];
  return <section className="py-20 px-4 bg-[#FFF8E7] border-t border-[#8B4513]/20" data-id="element-159">
      <div className="max-w-3xl mx-auto" data-id="element-160">
        <div className="text-center mb-12" data-id="element-161">
          <div className="inline-flex items-center justify-center p-3 bg-[#F4E8D8] rounded-full mb-4 border border-[#8B4513]/30" data-id="element-162">
            <HelpCircle className="w-8 h-8 text-[#7C2D2D]" data-id="element-163" />
          </div>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#2D241E] mb-4" data-id="element-164">
            Preguntas Frecuentes
          </h2>
          <p className="font-sans text-[#5D4037]" data-id="element-165">
            Resolvemos tus dudas antes de empezar
          </p>
        </div>

        <div className="bg-[#F4E8D8] rounded-lg border border-[#8B4513]/30 p-6 md:p-8 shadow-sm" data-id="element-166">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-167" />)}
        </div>
      </div>
    </section>;
}